module.exports = __webpack_public_path__ + "img/accessory_shoe_08.29e71e14.svg";